export const STICKY_SIDE_PANEL_CLASS = 'lg:sticky lg:top-app-header';
